import {
  PayrollCycle,
  payrollCycleCreateService,
  payrollCycleListService,
} from "services";

type RequestList = Parameters<typeof payrollCycleListService>[0];
type RequestCreate = Parameters<typeof payrollCycleCreateService>[0];
export enum PayrollCycleType {
  Month = "Month",
  Week = "Week",
  Day = "Day",
  Period = "Period",
}

type Types = {
  RequestList: RequestList & { date?: string[] };
  RequestCreate: RequestCreate;
  Model: PayrollCycle;
  Type: PayrollCycleType;
};

export default Types;
